"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _reactRouterDom = require("react-router-dom");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  z-index: 5;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  pointer-events: none;\n\n  @media (min-width: ", ") {\n    left: 50%;\n    width: ", ";\n    margin: 0 auto;\n    transform: translateX(-50%);\n  }\n"])), function (p) {
  return p.position || "fixed";
}, function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.navbarWidth;
});

var StyledSvg = _styledComponents.default.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  pointer-events: none;\n"])));

var StyledPath = _styledComponents.default.path(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));

var columnStyles = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 1 auto;\n  max-width: 50%;\n  width: 50%;\n  display: flex;\n  align-items: center;\n  background: ", ";\n"])), function (p) {
  return p.background;
});

var StyledColumnLeft = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  margin-right: 20px;\n  border-top-right-radius: 20px;\n"])), columnStyles);

var StyledColumnRight = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  margin-left: 20px;\n  border-top-left-radius: 20px;\n"])), columnStyles);

var StyledButton = (0, _styledComponents.default)(_reactRouterDom.NavLink)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex: 1 1 50%;\n  display: flex;\n  height: 80px;\n  padding-top: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  text-align: center;\n  color: ", ";\n  transition: transform 0.25s;\n  pointer-events: all;\n  text-decoration: none;\n\n  &.active {\n    color: white;\n  }\n"])), (0, _polished.rgba)("white", 0.5));

var StyledButtonText = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 0.675rem;\n  white-space: nowrap;\n"])));

var StyledBgWrapper = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: -1;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n"])));

var StyledNavbarIcon = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  flex: 0 0 68px;\n  padding: 2px;\n  width: 68px;\n  height: 68px;\n  transform: translateY(-10px);\n  border-radius: 50%;\n  background: ", ";\n"])), function (p) {
  return p.background;
});

var StyledIconImage = _styledComponents.default.img(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 64px;\n  height: 64px;\n"])));

var StyledIcon = _styledComponents.default.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin: 0 0 0.325rem;\n"])));

var Navbar = function Navbar(_ref) {
  var position = _ref.position,
      colorBackground = _ref.colorBackground,
      colorIcon = _ref.colorIcon,
      colorLink = _ref.colorLink,
      colorLinkActive = _ref.colorLinkActive,
      items = _ref.items,
      navbarIcon = _ref.navbarIcon,
      navbarWidth = _ref.navbarWidth;
  var itemsLeft = [items[0], items[1]];
  var itemsRight = [items[2], items[3]];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    position: position,
    navbarWidth: navbarWidth,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBgWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSvg, {
        height: "80",
        viewBox: "0 0 376 80",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPath, {
          d: "M0 0V90H376V0H260C243.984 0 231 12.9837 231 29V27.75V27H230.992C230.997 27.2494 231 27.4994 231 27.75C231 49.3965 211.972 66.9444 188.5 66.9444C165.028 66.9444 146 49.3965 146 27.75C146 27.4994 146.003 27.2494 146.008 27H146V27.75V29C146 12.9837 133.016 0 117 0H0Z",
          fill: colorBackground
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColumnLeft, {
      background: colorBackground,
      children: itemsLeft.map(function (item, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, {
          to: item.to,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
            className: "material-icons",
            children: item.icon
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonText, {
            children: item.text
          })]
        });
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavbarIcon, {
      background: colorIcon,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconImage, {
        src: navbarIcon
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColumnRight, {
      background: colorBackground,
      children: itemsRight.map(function (item, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, {
          to: item.to,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
            className: "material-icons",
            children: item.icon
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonText, {
            children: item.text
          })]
        });
      })
    })]
  });
};

var _default = Navbar;
exports.default = _default;